import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-27377a82"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "home-wrapper"
};
const _hoisted_2 = {
  class: "home-list-content"
};
const _hoisted_3 = {
  class: "first-module-box"
};
const _hoisted_4 = {
  class: "module-container",
  style: {
    "margin-top": "-70px"
  }
};
const _hoisted_5 = {
  class: "module-container"
};
const _hoisted_6 = {
  class: "course-resource"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_BannerList = _resolveComponent("BannerList");

  const _component_CourseGroup = _resolveComponent("CourseGroup");

  const _component_News = _resolveComponent("News");

  const _component_Teacher = _resolveComponent("Teacher");

  const _component_Lecture = _resolveComponent("Lecture");

  const _component_MoocCourse = _resolveComponent("MoocCourse");

  const _component_TeachingCourses = _resolveComponent("TeachingCourses");

  const _component_TeachingCenterList = _resolveComponent("TeachingCenterList");

  const _component_ResourceBase = _resolveComponent("ResourceBase");

  const _component_Link = _resolveComponent("Link");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_Head, {
    isFixed: "",
    menuCode: $data.menuCode,
    onGetUserInfo: $options.getUserInfo,
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    onUserRole: $options.getZhsRole
  }, null, 8, ["menuCode", "onGetUserInfo", "menuInfo", "onUserRole"]), $data.bannerItem && $data.bannerItem.home_open ? (_openBlock(), _createBlock(_component_BannerList, {
    key: 0
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$data.courseGroupItem && $data.courseGroupItem.home_open ? (_openBlock(), _createBlock(_component_CourseGroup, {
    key: 0,
    menu: $data.courseGroupItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), $data.newsItem && $data.newsItem.home_open ? (_openBlock(), _createBlock(_component_News, {
    key: 1,
    menu: $data.newsItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [$data.teacherItem && $data.teacherItem.home_open ? (_openBlock(), _createBlock(_component_Teacher, {
    key: 0,
    menu: $data.teacherItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), $data.lectureItem && $data.lectureItem.home_open ? (_openBlock(), _createBlock(_component_Lecture, {
    key: 1,
    menu: $data.lectureItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [$data.moocItem && $data.moocItem.function_id == '10401' && $data.moocItem.home_open ? (_openBlock(), _createBlock(_component_MoocCourse, {
    key: 0,
    menu: $data.moocItem,
    userInfo: $data.userInfo
  }, null, 8, ["menu", "userInfo"])) : _createCommentVNode("", true), $data.teachingCourseItem && $data.teachingCourseItem.function_id == '51006' && $data.teachingCourseItem.home_open ? (_openBlock(), _createBlock(_component_TeachingCourses, {
    key: 1,
    menu: $data.teachingCourseItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), $data.teachingCenterItem && $data.teachingCenterItem.function_id == '51001' && $data.teachingCenterItem.home_open ? (_openBlock(), _createBlock(_component_TeachingCenterList, {
    key: 2,
    menu: $data.teachingCenterItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true)])]), $data.resourceItem && $data.resourceItem.home_open ? (_openBlock(), _createBlock(_component_ResourceBase, {
    key: 1,
    menu: $data.resourceItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), $data.footerItem && $data.footerItem.home_open ? (_openBlock(), _createBlock(_component_Link, {
    key: 2,
    menu: $data.footerItem
  }, null, 8, ["menu"])) : _createCommentVNode("", true), _createVNode(_component_Footer)])]);
}